import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Field } from '@/components/form/field';
import { FormError } from '@/components/form/form-error';
import { PasswordInput } from '@/components/form/password-input';
import { useZodForm } from '@/components/form/use-zod-form';
import { Button } from '@/components/ui/button';
import { resetPassword } from '../api/auth';
import { AuthCard } from '../components/auth-card';
import { useLinkToken } from '../use-link-token';
import { MIN_PASSWORD_LENGTH, newPasswordWithConfirmation } from '../schemas';

export function ResetPasswordPage() {
  const token = useLinkToken();
  const form = useZodForm(newPasswordWithConfirmation, { password: '', confirmation: '' });
  const [done, setDone] = useState(false);
  const [serverError, setServerError] = useState<unknown>(null);

  const onSubmit = form.handleSubmit(async ({ password }) => {
    setServerError(null);
    try {
      await resetPassword(token, password);
      setDone(true);
    } catch (caught) {
      setServerError(caught);
    }
  });

  if (done) {
    return (
      <AuthCard title="Senha redefinida" description="Todas as sessões abertas foram encerradas.">
        <Button asChild className="w-full">
          <Link to="/entrar">Entrar</Link>
        </Button>
      </AuthCard>
    );
  }

  return (
    <AuthCard
      title="Nova senha"
      description={`Use pelo menos ${MIN_PASSWORD_LENGTH} caracteres; uma frase é mais forte e mais fácil de lembrar.`}
    >
      <form onSubmit={onSubmit} className="space-y-4" noValidate>
        <FormError error={serverError} fallback="Não foi possível redefinir a senha." />
        <Field
          control={form.control}
          name="password"
          label="Nova senha"
          required
          hint={`Mínimo de ${MIN_PASSWORD_LENGTH} caracteres.`}
        >
          {(field) => <PasswordInput {...field} autoComplete="new-password" />}
        </Field>
        <Field control={form.control} name="confirmation" label="Repita a senha" required>
          {(field) => <PasswordInput {...field} autoComplete="new-password" />}
        </Field>
        <Button type="submit" className="w-full" disabled={form.formState.isSubmitting}>
          {form.formState.isSubmitting ? 'Salvando…' : 'Salvar nova senha'}
        </Button>
      </form>
    </AuthCard>
  );
}
